<template>
  <div
    :class="['connection-box', 'bottom-md', screenBoxClass]"
    name="step4-check-screen"
    v-if="screenMonitoring">
    <div class="before">
      <button
        type="button"
        class="btn btn-dark btn-lg icon icon-connection"
        @click="handleScreenConnected"
        name="connect-screen">
        {{
          reconnect
            ? $t('preRegistration.step4.screen.reconnect')
            : $t('preRegistration.step4.screen.connect')
        }}
      </button>
      <p class="guide-text">
        {{
          reconnect
            ? $t('preRegistration.step4.screen.guide.reconnect')
            : $t('preRegistration.step4.screen.guide.connect')
        }}
      </p>
    </div>
    <div class="after">
      <div class="video-box">
        <video
          autoplay=""
          playsinline=""
          class="face_video"
          muted=""
          id="screen_connect_check"></video>
      </div>
    </div>
    <div class="cam-print-done">
      <div class="icon-confirm">
        <p>{{ $t('preRegistration.step4.screen.connectComplete') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    DEVICE_TYPE,
    CONNECT_CHECK_PHASE,
    DEFAULT_VIDEO_CHECK_TIMEOUT,
  } from '@/js/common/constants';
  import AntMediaConnectCheck from '@/js/video/antmedia/AntMediaConnectCheck';
  import {debounce} from 'lodash';

  export default {
    name: 'Screen',

    props: {
      userId: {
        type: Number,
      },
      roomId: {
        type: String,
      },
      screenMonitoring: {
        type: Boolean,
        default: false,
      },
      phase: {
        type: Number,
      },
      active: {
        type: Boolean,
        default: false,
      },
      done: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        webRTCAdaptor: null,
        timeoutId: null,

        connectDisabled: false,
        reconnect: false,
      };
    },

    beforeDestroy() {
      this.clearStreamInterval();
    },

    methods: {
      handleScreenConnected() {
        this.connectDisabled = true;
        this.debounceConnected();
      },

      debounceConnected: debounce(function () {
        this.openWebRTC();
      }, 1000),

      openWebRTC() {
        const {
          userId,
          roomId: videoRoomId,
          startTimer,
          handlePublishFinished,
          handleScreenCanceled,
          handleScreenShareModeNotAllowed,
          onDeviceNotSupported,
          close,
        } = this;

        this.webRTCAdaptor = new AntMediaConnectCheck({
          videoRoomId,
          publishType: DEVICE_TYPE['SCREEN_SHARE'],
          userId,
          localVideoId: 'screen_connect_check',
          isPlayMode: false,
          startTimer,
          handlePublishFinished,
          handleScreenCanceled,
          handleScreenShareModeNotAllowed,
          onDeviceNotSupported,
          close,
        });
      },

      clearStreamInterval() {
        if (!this.webRTCAdaptor) return;
        this.webRTCAdaptor.clearStreamInterval();
      },

      handleScreenCanceled() {
        this.handleModal(
          this.$t('preRegistration.step4.alert.screenShareCanceled'),
        );
      },

      handleScreenShareModeNotAllowed() {
        this.handleModal(
          this.$t(
            'preRegistration.step4.alert.pleaseChooseFullScreenForShareScreen',
          ),
        );
      },

      onDeviceNotSupported() {
        this.handleModal(this.$t('error.deviceNotSupported'));
      },

      startTimer() {
        this.$emit('changeScreenActive', true);

        this.timeoutId = setTimeout(() => {
          this.reconnect = false;
          this.closeWebRTC();

          this.$emit('changeScreenActive', false);
          this.$emit('connectStatusChanged', DEVICE_TYPE['SCREEN_SHARE'], true);
        }, DEFAULT_VIDEO_CHECK_TIMEOUT);
      },

      handlePublishFinished() {
        this.webRTCAdaptor.closeWebSocket();
        this.webRTCAdaptor = null;
      },

      closeWebRTC() {
        this.webRTCAdaptor.stop();
        this.webRTCAdaptor.closeStream();
        this.webRTCAdaptor.closePeerConnection();
      },

      close() {
        this.$emit('changeScreenActive', false);
        clearTimeout(this.timeoutId);
        this.reconnect = true;
        this.connectDisabled = false;
        this.closeWebRTC();
      },

      handleModal(message) {
        this.showModal(null, message);
        this.hideModal(null, () => {
          this.close();
          this.webRTCAdaptor.closeWebSocket();
        });
      },
    },

    computed: {
      screenBoxClass() {
        return {
          'tab-selected': this.phase === CONNECT_CHECK_PHASE['SCREEN'],
          active: this.active,
          done: this.done,
        };
      },
    },
  };
</script>
